var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.video_source)?_c('video',{staticStyle:{"max-width":"100%","max-height":"500px","object-fit":"cover"},attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.video_source,"type":"video/mp4"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }